'use client';

import { memo } from 'react';

// import NavbarPrivate from '@/features/v2/shared/Header/navbars/navbarPrivate/NavbarPrivate';
// import NavbarPublic from '@/features/v2/shared/Header/navbars/NavbarPublic';

// import { useAuth } from '@/core/auth/client/AuthProvider';

import Image from 'next/image';

import { HeaderProps } from '../interfaces';
import LoopVideo from './LoopVideo';

const HeaderOptimized = memo(({
  image = '', children, isVideo, loopVideoProps = {
    images: [],
  },
}: HeaderProps) => {
  return (
    <header className="relative w-full md:pt-14" aria-label="Banner principal">
      { image && (
        <Image
          src={image}
          alt="Fondo del banner principal de Powerbet"
          className="absolute inset-0 w-full h-full object-cover z-0 opacity-20 mask"
          width={300}
          height={317}
          priority
          quality={75}
        />
      )}
      <div className="relative flex flex-col md:flex-row-reverse items-center justify-center z-10 text-center">
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        {isVideo && <LoopVideo {...loopVideoProps} />}
        {children}
      </div>
      <div className="fade-bottom" />
    </header>
  );
});

HeaderOptimized.displayName = 'HeaderOptimized';

export default HeaderOptimized;
